module.exports = __webpack_public_path__ + "media/images/landing/bg/video-poster-mac-eeed46a26c4b615208e5a11b578a8fd8.jpg";